import IStopDataReport from "@/models/reports/stop-data.report";
import ReportFeature from "./report.feature";

export default class StopFeature extends ReportFeature {

    constructor(stop: IStopDataReport) {
        super(stop, 'pointer_stop', stop.index?.toString() || '', 'stop')
    }

}